import { VillageDetailPage } from "@/features/geolocation/page/VillageDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/geolocation/village/$id/detail")({
  component: VillageDetailPage,
});
